<template>
  <div v-if="hasProtexApplication">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
const fitmentDisplayStore = useFitmentDisplayStore()
const fitmentStore = useFitmentStore()
const protex = useProtex()

const emit = defineEmits(['hasApplication'])

// Define Props
const { productLineSlug, endpoint = 'rt' } = defineProps<{
  productLineSlug: string
  endpoint?: ProtexEndpoint
}>()

const { data: hasProtexApplication, refresh } = await useAsyncData(`protex-data-${endpoint}`, async () => {
  if (!fitmentDisplayStore.hasFullFitment) return false

  return protex.hasFitment(
    {
      make: fitmentStore.$state.makeSlug,
      model: fitmentStore.$state.modelSlug,
      year: fitmentStore.$state.year,
      bed: fitmentStore.$state.bedSlug,
      body: fitmentStore.$state.bodySlug,
    },
    productLineSlug,
    endpoint
  )
})

onMounted(() => {
  emit('hasApplication', hasProtexApplication.value)
})

// Hit protex API again if fitment changes
watch(fitmentStore.$state, async () => {
  await refresh()
  emit('hasApplication', hasProtexApplication.value)
})
</script>
